import { inferAdditionalFields } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { Auth } from "./server.ts";

/**
 * The browser-side auth client.
 *
 * `inferAdditionalFields<Auth>()` is a *type-only* bridge: it teaches the client
 * about `user.role` without pulling any server code into the bundle. The import
 * of `Auth` above is erased by `verbatimModuleSyntax` + `import type`.
 */
export function createClient(options: { baseURL: string }) {
	return createAuthClient({
		baseURL: options.baseURL,
		plugins: [inferAdditionalFields<Auth>()],
	});
}

export type AuthClient = ReturnType<typeof createClient>;
export type ClientSession = AuthClient["$Infer"]["Session"];
